import { prop, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { RateLine } from "./rate-line";
import { RateTemplate } from "./rate-template";

export class RateTemplateLine extends Resource {
    public override type = 'rateTemplateLines';

    @prop()
    @required()
    public rateTemplateId!: string;

    @prop()
    public rateTemplate!: RateTemplate;

    @prop()
    @required()
    public rateLineId!: string;

    @prop()
    public rateLine!: RateLine;

    @prop()
    public description!: string;

    @prop()
    public quantity!: number;

}